import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsMargin = {
  LOAD: ({ filter, sort, limit, skip }) =>
    `/v1/purchases/margin${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  LOAD_BY_OWN_STATION: ({ id, filter, sort, limit, skip }) =>
    `/v1/purchases/margin/ownStation/${id}${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
}

export default endpointsMargin
